import React, { Component, Fragment } from 'react'
import classnames from 'classnames'
import { Div, Loader, Span } from '@driftt/tide-core'
import { delay } from 'utils'

import { getImports } from 'api/imports'

import ImportsTable from 'components/ImportsTable'

import './style.css'

const Loading = ({ hasFinished }) => (
  <Div className={classnames("imports-table-loader", {'imports-table-loader--loaded': hasFinished})}>
    <Span>Finding your latest imports</Span>
    <Loader className="accounts-table-loader-animation" />
  </Div>
)

class ImportsHome extends Component {
  state = {
    importsLoading: true,
    importsHasLoaded: false,
    isFetchingNew: false,
    imports: [],
    size: 25,
    index: 0,
    searchString: ''
  }

  componentDidMount() {
    this.fetchImports()
  }

  setImportsLoaded = async () => {
    const start = () =>
      this.setState({
        importsHasLoaded: true,
        isFetchingNew: false
      })

    const complete = () =>
      this.setState({
        importsLoading: false
      })

    delay(start, 1200)
    delay(complete, 1200)
  }

  changeSize = ({ value }) => {
    this.setState({
      size: value
    }, this.fetchImports)
  }

  fetchImports = async () => {
    const { size, index } = this.state
    const { onReceiveImports } = this.props

    try {
      const { data: importsResponse } = await getImports({size, index})
      onReceiveImports(importsResponse)
      this.setImportsLoaded()
    } catch (err) {
      console.log(err)
    }
  }

  render() {
    const { isFetchingNew, importsLoading, importsHasLoaded } = this.state
    const { imports } = this.props

    return (
      <Fragment>
        <Div className="imports-home">
          {importsLoading && <Loading hasFinished={importsHasLoaded} />}
          {isFetchingNew &&
            <Span className="imports-home-table-fetcher">
              <Loader type="table" width={window.innerWidth - 60} />
            </Span>
          }
          <ImportsTable
            hasFinished={importsHasLoaded}
            imports={imports.results}
          />
        </Div>
      </Fragment>
    )
  }
}

export default ImportsHome
